import React from "react";

interface ISuspenseLoaderProps {
  type: string
}

const SuspenseLoader = ({type}: ISuspenseLoaderProps) => {
  return <h1>Loading {type}....</h1>
}


export default SuspenseLoader
